/**
 * IEDNEX Legal Pages i18n
 * Shared language switcher for Impressum / Datenschutz / AGB.
 * Each legal page defines `window.LEGAL_I18N = { de: {...}, en: {...} }` before including this file.
 */
(function () {
    var dict = window.LEGAL_I18N || { de: {}, en: {} };
    var currentLang = localStorage.getItem('iednex-lang') || 'de';
    if (!dict[currentLang]) currentLang = 'de';

    function apply() {
        document.documentElement.lang = currentLang;
        document.title = dict[currentLang]['page.title'] || document.title;

        document.querySelectorAll('[data-i18n]').forEach(function (el) {
            var k = el.getAttribute('data-i18n');
            if (dict[currentLang][k]) el.textContent = dict[currentLang][k];
        });
        document.querySelectorAll('[data-i18n-html]').forEach(function (el) {
            var k = el.getAttribute('data-i18n-html');
            if (dict[currentLang][k]) el.innerHTML = dict[currentLang][k];
        });
        document.querySelectorAll('[data-i18n-placeholder]').forEach(function (el) {
            var k = el.getAttribute('data-i18n-placeholder');
            if (dict[currentLang][k]) el.setAttribute('placeholder', dict[currentLang][k]);
        });
        document.querySelectorAll('.lang-btn').forEach(function (b) {
            b.classList.toggle('active', b.getAttribute('data-lang') === currentLang);
        });
    }

    function setLang(l) {
        currentLang = l;
        try { localStorage.setItem('iednex-lang', l); } catch (e) {}
        apply();
    }

    function init() {
        document.querySelectorAll('.lang-btn').forEach(function (b) {
            b.addEventListener('click', function () { setLang(b.getAttribute('data-lang')); });
        });
        apply();
    }

    if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', init);
    } else {
        init();
    }
})();
